import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import { trackPromise } from "react-promise-tracker";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import AuthService from "../../../../services/login/auth.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faFilePdf, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
const tokenActivo = sessionStorage.getItem('tieneToken');
export default class TransferenciaInterbancaria extends Component {
  constructor(props) {
    super(props);
  }


    
  

  descargar = async () => {
    //console.log("DESCARGAR");
    await trackPromise(
      TransferInterbancaService.descagarComponente(
        "Transferencia Interbancaria",
        this.props.nroOperacion,
        this.props.cuentaOrigen.ahorro +
        " - " +
        AuthService.getSocio().nombreCompleto.trim(),
        this.props.cuentaOrigen.descripcion,
        this.props.cuentaOrigen.moneda,
        this.props.cuentaOrigen.ahorro,
        this.props.cuentaDestino.nroCuenta,
        this.props.importe,
        this.props.importe,
        this.props.cuentaDestino.titular,
        this.props.cuentaDestino.entidad,
        this.props.cuentaDestino.tipoDocDestino,
        this.props.cuentaDestino.docDestino
      )
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };

  render() {
    if (this.props.currentStep === 4) {
      mensajeExito("La Transferencia se Realizó Correctamente");
    }

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Transferencia</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10" style={{ textAlign: "end" }}>
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
                <div className="col-8" style={{ marginBottom: 5 }}>
                  <h6 className="item-vef" style={{ margin: 0 }}>
                    Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                    {AuthService.getSocio().nombreCompleto.trim()}
                  </h6>
                  <p className="item-vef" style={{ marginBottom: 0 }}>
                    Tipo: {this.props.cuentaOrigen.descripcion}
                  </p>
                  <p className="item-vef">Moneda: {this.props.cuentaOrigen.moneda}</p>
                </div>
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Cuenta Crédito:</th>
                          <td>{this.props.cuentaDestino.nroCuenta}</td>
                        </tr>
                        <tr>
                          <th>Importe del Crédito:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "}
                            {this.props.cuentaOrigen.moneda}.
                          </td>
                        </tr>
                        <tr>
                          <th>Titular de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.titular}</td>
                        </tr>
                        <tr>
                          <th>Tipo documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.tipoDocDestino}</td>
                        </tr>
                        <tr>
                          <th>Documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.docDestino}</td>
                        </tr>
                        <tr>
                          <th>Entidad:</th>
                          <td>{this.props.cuentaDestino.entidad}</td>
                        </tr>
                        <tr>
                          <th>Fecha de Operación:</th>
                          <td>
                            {new Date().toLocaleDateString("es-ES", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                   
                      {
                        tokenActivo === "S" ?
                        <div className="callout importante">

                            <FontAwesomeIcon icon={faExclamationCircle} className="card-fa-icono-info" style={{ marginRight: 5, fontSize: 25 }} />
                          
                            <h3 style={{ fontSize: 20, fontWeight:"500" }}>Importante!</h3>
                    

                            - El horario de SIPAP para envío de transacciones es
                            de 09:00hs a 17:00hs. Los pagos enviados posterior
                            al horario de SIPAP serán procesados al siguiente
                            día hábil.
                            <br />
                            - El límite diario es de 30.000.000 Gs. y el límite
                            mensual es de 150.000.000 Gs
                            <br />
                            - Cantidad de operaciones sin costo: 7<br />
                            - Monto a descontar al exceder las 7 operaciones:
                            5.500 Gs.
                            <br />
                            - Todas las operaciones realizadas son de exclusiva
                            responsabilidad del socio, en caso de errores en la
                            imputación de las transferencias, las reversiones
                            dependen de la aprobación de la entidad receptora.
                            <br />
                          
                      </div>
                      :
                     <div className="callout importante">

                     <FontAwesomeIcon icon={faExclamationCircle} className="card-fa-icono-info" style={{ marginRight: 5, fontSize: 25 }} />
                   
                     <h3 style={{ fontSize: 20, fontWeight:"500" }}>Importante!</h3>
             

                     - El horario de SIPAP para envío de transacciones es
                     de 09:00hs a 17:00hs. Los pagos enviados posterior
                     al horario de SIPAP serán procesados al siguiente
                     día hábil.
                     <br />
                     - El límite diario es de 10.000.000 Gs. y el límite
                     mensual es de 50.000.000 Gs
                     <br />
                     - Cantidad de operaciones sin costo: 7<br />
                     - Monto a descontar al exceder las 7 operaciones:
                     5.500 Gs.
                     <br />
                     - Todas las operaciones realizadas son de exclusiva
                     responsabilidad del socio, en caso de errores en la
                     imputación de las transferencias, las reversiones
                     dependen de la aprobación de la entidad receptora.
                     <br />
                   
               </div>
                            }

                </div>
              
              </div>
    
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-lg-8 col-md-6"></div>
          <div className="col-lg-2 col-md-3">
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            onClick={this.props.firstStep}
          ></button>
          <button
            className="btn btn-cu-quintary btn-consulta"
            onClick={(e) => {
              this.props.returnDataPaso4();
              this.nextStep.click();
            }}
          >
          <FontAwesomeIcon icon={faPlus} />  Nueva Transacción
          </button>
          </div>
          <div className="col-lg-2 col-md-3">
          <button className="btn btn-cu-primary" onClick={this.descargar}>
           <FontAwesomeIcon icon={faFilePdf} />  Descargar Comprobante
          </button>
          </div>
        </div>
      </div>
    );
  }
}
